import { action, global } from '../const';
import { getServerResponse, onException } from '../functions';
import { reSignIn, getWcUsersInfo } from './Auth';
import { localStorage } from '../functions/AsyncStorage';

export const updateChatState = (payload) => {
    return {
        type: action.UPDATE_CHAT_STATE,
        payload
    };
};

const FailurRequest = (data, callback) => {
    if (!data) return;
    return async (dispatch) => {
        if (data.error && data.error === 121) {
            let res = await dispatch(reSignIn())
            if (!res) return false
            return dispatch(callback)
        }
    }
};


export const groupConversation = () => {

    return async (dispatch, getState) => {

        let { userInfo } = getState().auth;
        try {
            let response = await getServerResponse({ token: userInfo.token, cmd: 'WcLogin.getGroupMessages1' })
            if (response.error) return dispatch(FailurRequest(response, groupConversation()));
            const groupConversation = response.sort((a, b) => parseFloat(b.time) - parseFloat(a.time));
            localStorage(1, 'groupConversation', groupConversation)
            dispatch({
                type: action.CONVERSATION_LIST,
                groups: groupConversation
            });
        } catch (error) {
            onException(error)
            return;
        }
    };

};

export const groupInfo = (id) => {
    return async (dispatch, getState) => {
        let { auth, chat } = getState();
        try {
            let group = await getServerResponse({ group_id: id, time: 0, users_num: 0, user_id: auth.userInfo.id, token: auth.userInfo.token, cmd: "WcConnectUserInfo.getGroupPer2" });

            if (group.error) return dispatch(FailurRequest(group, groupInfo(id)));

            let all_groups = chat.groups;
            all_groups = Object.assign(all_groups, { [id]: group })
            dispatch(updateChatState({ groups: all_groups }));
            let member = group.members.match(/.*?,/g);
            if (member === null || member.length < 1000) dispatch(getWcUsersInfo(group.members))

            return group;
        } catch (error) {
            onException(error)
            return []
        }
    }
}

export const newConversation = () => {
    return async (dispatch, getState) => {
        let { userInfo } = getState().auth;
        try {
            let response = await getServerResponse({ user_id: userInfo.id, token: userInfo.token, cmd: "WcnFamily.getListForNewChat" })
            if (response.error) return dispatch(FailurRequest(response, newConversation()));
            dispatch({
                type: action.NEW_CONVERSATION_LIST,
                data: response
            })
            return response
        } catch (error) {
            alert(error);
            onException(error)
            return []
        }
    };
};

export const createGroup = (obj, user_ids, family_ids) => {
    return async (dispatch, getState) => {
        let { userInfo } = getState().auth;
        try {
            let response = await getServerResponse({ cmd: 'WcGroupChat.createGroup1', token: userInfo.token, user_id: userInfo.id, user_ids, family_ids })
            // if (response.error) return dispatch(FailurRequest(response, createGroup(obj, user_ids, family_ids)));
            // if (response.id && response.group_name) {
            //     return window.navigation(obj, global.isNative ? 'groupChat' : 'chat/conversation', { groupId: response.id, name: response.group_name }, `?groupId=${response.id}&name=${response.group_name}`);
            // }
            return response
        } catch (error) {
            onException(error)
            return null
        }
    };
};


// Socket Handlling Task

export function sendSocketmessage(data) {
    return () => {
        try {
            if (window.wsConnection) {
                if (window.wsConnection.readyState === window.wsConnection.OPEN) {
                    return window.wsConnection.send(JSON.stringify(data));
                }
            }
            window.socket(data) // open socket connection
        } catch (error) {
            console.log(error)
            setTimeout(() => {
                window.socket(data) // open socket connection
            }, 20000);
        }
    }
}

// [ #118 WoogiChatUser.login ] https://mainbackend.woogiu.com/woogi/0.1/doc/command.php?s=WoogiChatUser.login
export function socketLogin() {
    return (dispatch, getState) => {
        const { userInfo } = getState().auth;
        const { isSocketLogin } = getState().chat;
        if (userInfo && userInfo != null && !isSocketLogin) {
            dispatch(sendSocketmessage({ id: userInfo.id, cmd: "WoogiChatUser.login1" }))
        }
    }
}

// [ #79 GroupMessage.getHistory ]  https://mainbackend.woogiu.com/woogi/0.1/doc/command.php?s=GroupMessage.getHistory

export function getHistory(data) {
    return (dispatch, getState) => {
        let { groupId } = getState().chat;
        // let messages = []
        let { messages } = getState().chat;
        let list = data.list
        // messages.push()
        dispatch({
            type: action.GROUP_MESSAGES,
            messages: { groupId, list }
        })
    }
}

export function getGroupMessages(id) {
    return (dispatch, getState) => {
        let { messages } = getState().chat;
        messages = messages.filter(item => item.groupId === id);
        if (messages.length > 0) messages = messages[0].list
        return messages;
    }
}
